/**
 * Wave 11: Country SEO i18n — Additional language gaps
 * New countries: New Zealand, Pakistan, Malaysia (expanded)
 * Remaining gaps for Thailand, Indonesia, Bangladesh, Peru, Chile, Kenya, Ethiopia
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE11: CountrySEOMap = {

  newzealand: {
    en: {
      title: 'Call Center New Zealand | English Customer Service | Call IT Dev',
      description: 'Call center for New Zealand: English-speaking agents, CSAT 95%, 24/7 coverage. AgriTech and tourism support.',
      heroTitle: 'Call Center for New Zealand — English Support',
      heroSubtitle: 'Premium English customer service for New Zealand businesses at competitive rates.',
    },
    fr: {
      title: 'Centre d\'appel Nouvelle-Zélande | Service Client Anglophone | Call IT Dev',
      description: 'Centre d\'appel pour la Nouvelle-Zélande : agents anglophones, CSAT 95%, couverture 24/7.',
      heroTitle: 'Centre d\'appel pour la Nouvelle-Zélande — Support Anglophone',
      heroSubtitle: 'Service client premium pour les entreprises néo-zélandaises.',
    },
    zh: {
      title: '新西兰呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '新西兰呼叫中心外包：英语座席，CSAT 95%，24/7覆盖。',
      heroTitle: '新西兰呼叫中心 — 英语支持',
      heroSubtitle: '以竞争力价格为新西兰企业提供客户服务。',
    },
    ja: {
      title: 'ニュージーランドコールセンター | 英語サポート | Call IT Dev',
      description: 'ニュージーランド向けコールセンター：英語ネイティブ、CSAT 95%。',
      heroTitle: 'ニュージーランドコールセンター — 英語サポート',
      heroSubtitle: 'ニュージーランド企業向けプレミアムサービス。',
    },
    ko: {
      title: '뉴질랜드 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '뉴질랜드 콜센터: 영어 상담원, CSAT 95%.',
      heroTitle: '뉴질랜드 콜센터 — 영어 지원',
      heroSubtitle: '뉴질랜드 기업을 위한 프리미엄 서비스.',
    },
    de: {
      title: 'Callcenter Neuseeland | Englischsprachiger Kundenservice | Call IT Dev',
      description: 'Callcenter für Neuseeland: englischsprachige Agenten, CSAT 95%.',
      heroTitle: 'Callcenter für Neuseeland — Englischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für neuseeländische Unternehmen.',
    },
    sv: {
      title: 'Callcenter Nya Zeeland | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Nya Zeeland: engelsktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Nya Zeeland — Engelskt Stöd',
      heroSubtitle: 'Premium kundtjänst för nyzeeländska företag.',
    },
    da: {
      title: 'Callcenter New Zealand | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til New Zealand: engelsktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til New Zealand — Engelsk Support',
      heroSubtitle: 'Premium kundeservice for newzealandske virksomheder.',
    },
    ar: {
      title: 'مركز اتصال نيوزيلندا | خدمة عملاء بالإنجليزية | Call IT Dev',
      description: 'مركز اتصال لنيوزيلندا: وكلاء ناطقون بالإنجليزية، CSAT 95%.',
      heroTitle: 'مركز اتصال لنيوزيلندا — دعم بالإنجليزية',
      heroSubtitle: 'خدمة عملاء متميزة للشركات النيوزيلندية.',
    },
  },

  pakistan: {
    en: {
      title: 'Call Center Pakistan | English & Urdu Support | Call IT Dev',
      description: 'Call center for Pakistan: English & Urdu agents, CSAT 95%, competitive rates.',
      heroTitle: 'Call Center for Pakistan — English & Urdu Support',
      heroSubtitle: 'Premium bilingual customer service for Pakistan\'s growing digital economy.',
    },
    fr: {
      title: 'Centre d\'appel Pakistan | Support Anglais et Ourdou | Call IT Dev',
      description: 'Centre d\'appel pour le Pakistan : agents anglophones et ourdouphones, CSAT 95%.',
      heroTitle: 'Centre d\'appel pour le Pakistan — Support Bilingue',
      heroSubtitle: 'Service client premium pour l\'économie numérique pakistanaise.',
    },
    ar: {
      title: 'مركز اتصال باكستان | دعم بالإنجليزية والأردية | Call IT Dev',
      description: 'مركز اتصال لباكستان: وكلاء بالإنجليزية والأردية، CSAT 95%.',
      heroTitle: 'مركز اتصال لباكستان — دعم ثنائي اللغة',
      heroSubtitle: 'خدمة عملاء متميزة للاقتصاد الرقمي الباكستاني.',
    },
    zh: {
      title: '巴基斯坦呼叫中心 | 英语乌尔都语客服 | Call IT Dev',
      description: '巴基斯坦呼叫中心：英语和乌尔都语座席，CSAT 95%。',
      heroTitle: '巴基斯坦呼叫中心 — 英语乌尔都语支持',
      heroSubtitle: '为巴基斯坦数字经济提供优质客户服务。',
    },
    ja: {
      title: 'パキスタンコールセンター | 英語・ウルドゥー語サポート | Call IT Dev',
      description: 'パキスタン向けコールセンター：英語・ウルドゥー語、CSAT 95%。',
      heroTitle: 'パキスタンコールセンター — バイリンガルサポート',
      heroSubtitle: 'パキスタンのデジタル経済向けプレミアムサービス。',
    },
    ko: {
      title: '파키스탄 콜센터 | 영어 & 우르두어 지원 | Call IT Dev',
      description: '파키스탄 콜센터: 영어 및 우르두어 상담원, CSAT 95%.',
      heroTitle: '파키스탄 콜센터 — 이중 언어 지원',
      heroSubtitle: '파키스탄 디지털 경제를 위한 프리미엄 서비스.',
    },
    de: {
      title: 'Callcenter Pakistan | Englisch & Urdu Support | Call IT Dev',
      description: 'Callcenter für Pakistan: Englisch- und Urdu-Agenten, CSAT 95%.',
      heroTitle: 'Callcenter für Pakistan — Zweisprachiger Support',
      heroSubtitle: 'Premium-Service für Pakistans digitale Wirtschaft.',
    },
    sv: {
      title: 'Callcenter Pakistan | Engelska & Urdu Kundtjänst | Call IT Dev',
      description: 'Callcenter för Pakistan: engelska och urdu agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Pakistan — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för Pakistans digitala ekonomi.',
    },
    da: {
      title: 'Callcenter Pakistan | Engelsk & Urdu Kundeservice | Call IT Dev',
      description: 'Callcenter til Pakistan: engelske og urdu agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Pakistan — Tosproget Support',
      heroSubtitle: 'Premium kundeservice for Pakistans digitale økonomi.',
    },
  },

  thailand: {
    zh: {
      title: '泰国呼叫中心 | 泰语客服外包 | Call IT Dev',
      description: '泰国呼叫中心外包：泰语座席，CSAT 95%，极具竞争力的价格。',
      heroTitle: '泰国呼叫中心 — 泰语支持',
      heroSubtitle: '以竞争力价格为泰国市场提供泰语客户服务。',
    },
    ja: {
      title: 'タイコールセンター | タイ語サポート | Call IT Dev',
      description: 'タイ向けコールセンター：タイ語ネイティブ、CSAT 95%。',
      heroTitle: 'タイコールセンター — タイ語サポート',
      heroSubtitle: '競争力のある価格でタイ市場にサービスを。',
    },
    ko: {
      title: '태국 콜센터 | 태국어 고객 서비스 | Call IT Dev',
      description: '태국 콜센터: 태국어 상담원, CSAT 95%.',
      heroTitle: '태국 콜센터 — 태국어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 태국 시장에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Thailand | Thailändsk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Thailand: thailändsktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Thailand — Thailändskt Stöd',
      heroSubtitle: 'Premium kundtjänst på thailändska.',
    },
    da: {
      title: 'Callcenter Thailand | Thailandsk Kundeservice | Call IT Dev',
      description: 'Callcenter til Thailand: thailandsktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Thailand — Thailandsk Support',
      heroSubtitle: 'Premium kundeservice på thailandsk.',
    },
  },

  indonesia: {
    zh: {
      title: '印度尼西亚呼叫中心 | 印尼语客服 | Call IT Dev',
      description: '印度尼西亚呼叫中心：印尼语座席，CSAT 95%。',
      heroTitle: '印度尼西亚呼叫中心 — 印尼语支持',
      heroSubtitle: '为东南亚最大经济体提供客户服务。',
    },
    ja: {
      title: 'インドネシアコールセンター | インドネシア語サポート | Call IT Dev',
      description: 'インドネシア向けコールセンター：インドネシア語、CSAT 95%。',
      heroTitle: 'インドネシアコールセンター — インドネシア語サポート',
      heroSubtitle: '東南アジア最大の経済大国にサービスを。',
    },
    ko: {
      title: '인도네시아 콜센터 | 인도네시아어 서비스 | Call IT Dev',
      description: '인도네시아 콜센터: 인도네시아어 상담원, CSAT 95%.',
      heroTitle: '인도네시아 콜센터 — 인도네시아어 지원',
      heroSubtitle: '동남아시아 최대 경제국에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Indonesien | Indonesisk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Indonesien: indonesisktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Indonesien — Indonesiskt Stöd',
      heroSubtitle: 'Premium kundtjänst för Sydostasiens största ekonomi.',
    },
    da: {
      title: 'Callcenter Indonesien | Indonesisk Kundeservice | Call IT Dev',
      description: 'Callcenter til Indonesien: indonesisktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Indonesien — Indonesisk Support',
      heroSubtitle: 'Premium kundeservice for Sydøstasiens største økonomi.',
    },
  },

  bangladesh: {
    zh: {
      title: '孟加拉国呼叫中心 | 英语孟加拉语客服 | Call IT Dev',
      description: '孟加拉国呼叫中心：英语和孟加拉语座席，CSAT 95%。',
      heroTitle: '孟加拉国呼叫中心 — 双语支持',
      heroSubtitle: '为孟加拉国市场提供竞争力价格的客户服务。',
    },
    ja: {
      title: 'バングラデシュコールセンター | 英語・ベンガル語サポート | Call IT Dev',
      description: 'バングラデシュ向けコールセンター：英語・ベンガル語、CSAT 95%。',
      heroTitle: 'バングラデシュコールセンター — バイリンガルサポート',
      heroSubtitle: '競争力のある価格でバングラデシュ市場にサービスを。',
    },
    ko: {
      title: '방글라데시 콜센터 | 영어 & 벵골어 서비스 | Call IT Dev',
      description: '방글라데시 콜센터: 영어 및 벵골어 상담원, CSAT 95%.',
      heroTitle: '방글라데시 콜센터 — 이중 언어 지원',
      heroSubtitle: '방글라데시 시장에 경쟁력 있는 고객 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Bangladesh | Engelska & Bengalisk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Bangladesh: engelska och bengaliska agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Bangladesh — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Bangladesh | Engelsk & Bengalsk Kundeservice | Call IT Dev',
      description: 'Callcenter til Bangladesh: engelske og bengalske agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Bangladesh — Tosproget Support',
      heroSubtitle: 'Premium kundeservice til konkurrencedygtige priser.',
    },
  },

  peru: {
    zh: {
      title: '秘鲁呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '秘鲁呼叫中心外包：西班牙语座席，CSAT 95%。',
      heroTitle: '秘鲁呼叫中心 — 西班牙语支持',
      heroSubtitle: '以竞争力价格为秘鲁市场提供西班牙语客户服务。',
    },
    ja: {
      title: 'ペルーコールセンター | スペイン語サポート | Call IT Dev',
      description: 'ペルー向けコールセンター：スペイン語、CSAT 95%。',
      heroTitle: 'ペルーコールセンター — スペイン語サポート',
      heroSubtitle: '競争力のある価格でペルー市場にサービスを。',
    },
    ko: {
      title: '페루 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '페루 콜센터: 스페인어 상담원, CSAT 95%.',
      heroTitle: '페루 콜센터 — 스페인어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 페루 시장에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Peru | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Peru: spansktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Peru — Spanskt Stöd',
      heroSubtitle: 'Premium kundtjänst på spanska.',
    },
    da: {
      title: 'Callcenter Peru | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Peru: spansktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Peru — Spansk Support',
      heroSubtitle: 'Premium kundeservice på spansk.',
    },
  },

  chile: {
    zh: {
      title: '智利呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '智利呼叫中心外包：西班牙语座席，CSAT 95%。',
      heroTitle: '智利呼叫中心 — 西班牙语支持',
      heroSubtitle: '以竞争力价格为智利市场提供西班牙语客户服务。',
    },
    ja: {
      title: 'チリコールセンター | スペイン語サポート | Call IT Dev',
      description: 'チリ向けコールセンター：スペイン語、CSAT 95%。',
      heroTitle: 'チリコールセンター — スペイン語サポート',
      heroSubtitle: '競争力のある価格でチリ市場にサービスを。',
    },
    ko: {
      title: '칠레 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '칠레 콜센터: 스페인어 상담원, CSAT 95%.',
      heroTitle: '칠레 콜센터 — 스페인어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 칠레 시장에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Chile | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Chile: spansktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Chile — Spanskt Stöd',
      heroSubtitle: 'Premium kundtjänst på spanska.',
    },
    da: {
      title: 'Callcenter Chile | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Chile: spansktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Chile — Spansk Support',
      heroSubtitle: 'Premium kundeservice på spansk.',
    },
  },

  kenya: {
    zh: {
      title: '肯尼亚呼叫中心 | 英语斯瓦希里语客服 | Call IT Dev',
      description: '肯尼亚呼叫中心：英语和斯瓦希里语座席，CSAT 95%。',
      heroTitle: '肯尼亚呼叫中心 — 双语支持',
      heroSubtitle: '以竞争力价格为东非最大经济体提供客户服务。',
    },
    ja: {
      title: 'ケニアコールセンター | 英語・スワヒリ語サポート | Call IT Dev',
      description: 'ケニア向けコールセンター：英語・スワヒリ語、CSAT 95%。',
      heroTitle: 'ケニアコールセンター — バイリンガルサポート',
      heroSubtitle: '東アフリカ最大の経済大国にサービスを。',
    },
    ko: {
      title: '케냐 콜센터 | 영어 & 스와힐리어 서비스 | Call IT Dev',
      description: '케냐 콜센터: 영어 및 스와힐리어 상담원, CSAT 95%.',
      heroTitle: '케냐 콜센터 — 이중 언어 지원',
      heroSubtitle: '동아프리카 최대 경제국에 고객 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Kenya | Engelska & Swahili Kundtjänst | Call IT Dev',
      description: 'Callcenter för Kenya: engelska och swahili agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Kenya — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för Östafrikas största ekonomi.',
    },
    da: {
      title: 'Callcenter Kenya | Engelsk & Swahili Kundeservice | Call IT Dev',
      description: 'Callcenter til Kenya: engelske og swahili agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Kenya — Tosproget Support',
      heroSubtitle: 'Premium kundeservice for Østafrikas største økonomi.',
    },
  },

  ethiopia: {
    zh: {
      title: '埃塞俄比亚呼叫中心 | 英语阿姆哈拉语客服 | Call IT Dev',
      description: '埃塞俄比亚呼叫中心：英语和阿姆哈拉语座席，CSAT 95%。',
      heroTitle: '埃塞俄比亚呼叫中心 — 双语支持',
      heroSubtitle: '以竞争力价格为非洲快速增长的经济体提供服务。',
    },
    ja: {
      title: 'エチオピアコールセンター | 英語サポート | Call IT Dev',
      description: 'エチオピア向けコールセンター：英語・アムハラ語、CSAT 95%。',
      heroTitle: 'エチオピアコールセンター — バイリンガルサポート',
      heroSubtitle: 'アフリカで最も急成長する経済大国にサービスを。',
    },
    ko: {
      title: '에티오피아 콜센터 | 영어 & 암하라어 서비스 | Call IT Dev',
      description: '에티오피아 콜센터: 영어 및 암하라어 상담원, CSAT 95%.',
      heroTitle: '에티오피아 콜센터 — 이중 언어 지원',
      heroSubtitle: '아프리카 가장 빠르게 성장하는 경제에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Etiopien | Engelska & Amharisk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Etiopien: engelska och amhariska agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Etiopien — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för Afrikas snabbast växande ekonomi.',
    },
    da: {
      title: 'Callcenter Etiopien | Engelsk & Amharisk Kundeservice | Call IT Dev',
      description: 'Callcenter til Etiopien: engelske og amhariske agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Etiopien — Tosproget Support',
      heroSubtitle: 'Premium kundeservice for Afrikas hurtigst voksende økonomi.',
    },
  },

  malaysia: {
    zh: {
      title: '马来西亚呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '马来西亚呼叫中心：马来语、英语、中文座席，CSAT 95%。',
      heroTitle: '马来西亚呼叫中心 — 多语种支持',
      heroSubtitle: '为东南亚重要经济体提供多语种客户服务。',
    },
    ja: {
      title: 'マレーシアコールセンター | 多言語サポート | Call IT Dev',
      description: 'マレーシア向けコールセンター：マレー語・英語・中国語、CSAT 95%。',
      heroTitle: 'マレーシアコールセンター — 多言語サポート',
      heroSubtitle: '東南アジアの重要な経済大国に多言語サービスを。',
    },
    ko: {
      title: '말레이시아 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '말레이시아 콜센터: 말레이어, 영어, 중국어 상담원, CSAT 95%.',
      heroTitle: '말레이시아 콜센터 — 다국어 지원',
      heroSubtitle: '동남아시아 주요 경제에 다국어 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Malaysia | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Malaysia: malajiska, engelska, kinesiska agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Malaysia — Flerspråkigt Stöd',
      heroSubtitle: 'Premium flerspråkig kundtjänst för Sydostasien.',
    },
    da: {
      title: 'Callcenter Malaysia | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Malaysia: malajiske, engelske, kinesiske agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Malaysia — Flersproget Support',
      heroSubtitle: 'Premium flersproget kundeservice for Sydøstasien.',
    },
  },
};
